import http from '@/js/http';
import { User } from '@/types';

export interface SignInRequest {
    username: string;
    password: string;
}

export interface SignInResponse {
    user: User;
    token: string;
}

export const AuthService = {
    async signIn(payload: SignInRequest) {
        const { data } = await http.post<SignInResponse>(`/signin`, payload);
        return data;
    },

    async signOut() {
        await http.post(`/signout`);
        return true;
    },

    async user() {
        const { data } = await http.get<User>(`/user`);
        return data;
    },
};
